import { Link } from 'react-router-dom';
import { BookOpen, FileText, ArrowRight, Layers } from 'lucide-react';
import { slugify, readingTime } from '../../data/insights';

const navItemClass = (active) =>
  `flex items-start gap-2.5 px-3 py-2 text-[0.95rem] border-l-2 transition-colors ${
    active ? 'border-purple bg-lilac/40 text-purple font-bold' : 'border-transparent text-ink/85 hover:border-ink hover:text-purple'
  }`;

export const InsightsSidebar = ({ topic, currentSlug, sections }) => (
  <aside className="space-y-6 lg:sticky lg:top-24" data-testid="insights-sidebar">
    <div className="hidden lg:block card-ink p-5" data-testid="insights-toc">
      <h3 className="label-caps text-purple mb-3">Inhalt</h3>
      <nav className="flex flex-col gap-1.5">
        {sections.map((s) => (
          <a key={s.heading} href={`#${slugify(s.heading)}`} className="text-[0.95rem] text-ink/80 hover:text-purple transition-colors leading-snug">
            {s.heading}
          </a>
        ))}
      </nav>
    </div>

    <div className="card-ink p-5" data-testid="insights-sidebar-nav">
      <h3 className="label-caps text-purple mb-3">Themenbereich</h3>
      <nav className="flex flex-col gap-1">
        <Link to={`/insights/${topic.slug}`} className={navItemClass(!currentSlug)} data-testid="sidebar-main-article-link">
          <BookOpen className="w-4 h-4 mt-1 flex-shrink-0" />
          <span>
            Leitfaden: {topic.title}
            <span className="block text-sm font-normal text-ink/60">{readingTime(topic.mainArticle)} Min. Lesezeit</span>
          </span>
        </Link>
        {topic.subArticles.map((a) => (
          <Link key={a.slug} to={`/insights/${topic.slug}/${a.slug}`} className={navItemClass(currentSlug === a.slug)} data-testid={`sidebar-article-link-${a.slug}`}>
            <FileText className="w-4 h-4 mt-1 flex-shrink-0" />
            <span>
              {a.title}
              <span className="block text-sm font-normal text-ink/60">{readingTime(a)} Min. Lesezeit</span>
            </span>
          </Link>
        ))}
      </nav>
    </div>

    <div className="card-ink bg-purple text-off p-6" data-testid="insights-cta-box">
      <span className="text-lilac text-2xl block mb-2" aria-hidden="true">✳</span>
      <h3 className="font-display font-bold text-xl mb-2">Du willst das Thema für deinen Betrieb angehen?</h3>
      <p className="opacity-90 text-[0.95rem] mb-5">Wir schauen gemeinsam auf deine Situation – kostenfrei, unverbindlich und herstellerneutral.</p>
      <Link to="/erstberatung" className="btn btn--lilac btn--sm btn--block" data-testid="insights-cta-btn">
        Kostenlose Erstberatung
        <ArrowRight className="w-5 h-5" />
      </Link>
    </div>

    <Link to="/loesungen" className="flex items-center gap-2 text-[0.95rem] text-ink/80 hover:text-purple transition-colors px-1" data-testid="insights-back-to-loesungen">
      <Layers className="w-4 h-4" />
      Zur Übersicht unserer Lösungen
    </Link>
  </aside>
);
